module.exports = __webpack_public_path__ + "media/images/webpage/hotels/895/plan4-1-2e8e61860dc0074a441457906fa5e7c2.webp";